var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableLayout',{attrs:{"permissions":['business:project:query']}},[_vm._v(" 12123 ")])}
var staticRenderFns = []

export { render, staticRenderFns }